/**
 * consentTextUi: モーダルの確定ボタン直上に表示する「会員情報・アポイント内容の通知／
 * 各種ご案内メールへの同意文言」の共通コンポーネント。
 * SurveyPopup・PreBookingForm・MultiCvAppointmentList の各確定ボタン直上で共有する。
 *
 * <p><b>文言確定（BR-U6-13、2026-09-04 事業支援部確認済み）</b>:
 * 日程調整が表示される時点でユーザーは会員であり、プライバシーポリシー・利用規約には既に同意済みの
 * ため、利用規約・プライバシーポリシーへの同意文言は表示しない。代わりに、対象企業への会員情報・
 * アポイント内容の通知と、各種ご案内メールへの同意文言を表示する（各モーダル／各CVごとに個別表示
 * する方針。レコメンド展開・スクロールで表示が変わっても確定ボタン直上に必ず出るようにするため）。
 * レコメンドCVの縦長を抑えるため文言は短縮版とし、対象企業名の明示行は廃止した。
 *
 * <p>Shadow DOM隔離（BR-U6-8）＋CSP対策のため、スタイルは文字列CSS定数 `CONSENT_TEXT_STYLES` として
 * 各Shadow Rootのスタイルへ連結する。
 */

import { createElement } from "../core/shadowDomUtil";
import { TEXT_SECONDARY } from "./designTokens";

// --- 確定文言（2026-09-04確定） ---
/** 同意本文（会員情報・アポイント内容の通知／各種ご案内メールへの同意）。 */
const CONSENT_TEXT_BODY =
  "※対象企業への会員情報・アポイント内容の通知、各種ご案内のメールに同意したことになります。";

/** 同意文言のスタイル（Shadow Root のスタイル定数へ連結して使用する）。 */
export const CONSENT_TEXT_STYLES = `
.spica-consent-text {
  margin: 12px 0 0;
  font-size: 11px;
  line-height: 1.6;
  color: ${TEXT_SECONDARY};
}

.spica-cv-item.recommend-cv .spica-consent-text {
  font-size: 10px;
  line-height: 1.5;
  margin-top: 8px;
}
`;

/**
 * 同意文言のDOMを生成する。
 *
 * 本文は共通の確定文言（`CONSENT_TEXT_BODY`）を表示する。文言短縮に伴い「対象企業：〇〇」の
 * 明示行は廃止済みのため、引数は取らない。
 */
export function renderConsentText(): HTMLElement {
  const container = createElement("div", { className: "spica-consent-text" });

  // 同意本文（対象企業への通知・各種ご案内メールへの同意）
  container.appendChild(document.createTextNode(CONSENT_TEXT_BODY));

  return container;
}
